import { Injectable, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AuthenticationService } from '../auth/authentication.service';
import { PermissionService } from '../auth/permission.service';
import { LanguageTranslateService } from './language-translate.service';
import { SubscriptionUtil } from '../_utilities/subscription';
import { map } from 'rxjs/operators';

@Injectable()
export class  MenuService extends SubscriptionUtil {

  private menuSource = new Subject<any>();
  menuSourceHandler = this.menuSource.asObservable();

  private resetSource = new Subject();
  resetSource$ = this.resetSource.asObservable();

  rootLevelNodes: any;
  company!: boolean;
  users!: boolean;
  // profiles!: boolean;
  // roles!: boolean;
  billing!: boolean;
  licenses!: boolean;
  // manageTickets!: boolean;
  // manageInventory!: boolean;
  manageImportExport!: boolean;
  manageShifts!: boolean;
  // manageNotification!: boolean;
  // manageGeofence!: boolean;
  salePer: boolean = false;
  servicePer: boolean = false;
  fleetPer: boolean = false;
  addonFeature: any;
  // drivers!: boolean;
  menuType: any;
  // fleetSetup!: boolean;
  assets!: boolean;
  jobs!: boolean;
  tickets!: boolean;
  packages!: boolean;
  vehicles!: boolean;
  module!: boolean;
  workflow!: boolean;
  menuRename:any ={
    site:"Site",
    asset:"Asset",
    customer:"Customer"
  }
  calendlyIntegration!: boolean;
  customerSurveyLink!: boolean;
  teams!: boolean;
  site!: boolean;
  project!: boolean;
  translate: any;
  displayAssets!: boolean;
tenantPackages: any;
  displayProject!: boolean;
  displayTickets!: boolean;
tenantPackagesContract: any; //to get tenant packages from authentication service
  displayWorkflow!: boolean;
  displayLabel!: boolean;
  tenantPackagesProject: any;
  displayContract!: boolean;
  displayPM!: boolean;
  displayJoTemp!: boolean; // Flag to control job order template visibility
  packageCode!: string;
  displaySurvey!: boolean;
  displayConReq!: boolean;
  LicenseBilling: boolean = false;
  hideBaseOnPackage: any={
    approval: true,
    assetPicklist: true,
    assetListView: true,
    contracts: true,
    contractListView: true,
    customerPicklist: true,
    customerListView: false,
    general: true,
    jobOrderPicklist: true,
    jobOrderListView: true,
    projectPicklist: true,
    projectListView: true,
    site: true,
    sitePicklist: true,
    siteListView: true,
    productListView: true,
    pmListView: true,
    salesOrderPicklist: true,
    salesOrderListView: true,
    ticketPicklist: true,
    taskListView: true,
    inventory: true,
    hierarchy: true,
    skill: true

  };
  displayNewPM3: boolean= false;

  isJOTypeHidden: boolean; //flag to control new addOn (JO2) visibility: used in new Type menu in setup
  isMansorTenant: boolean; 
  displayCustomerPortal: boolean;
  displayNewAsset: boolean; //flag to control new addon SETUP2 visibility for new Asset Type and Statuses in Setup
  
  displayNewWORKFLOW2: boolean = false;


  constructor(private perm: PermissionService,
    private auth: AuthenticationService,
    private languageTranslateService: LanguageTranslateService) {
      super()
      
     }


  onMenuStateChange(items: any) {
    this.menuSource.next(items);
  }

  reset() {
    this.resetSource.next(null);
  }
  initPermission() {

   

    this.company = this.perm.capable('manage_org_detail', 'read');
    // this.profiles = this.perm.capable('manage access', 'read');
    // this.roles = this.perm.capable('manage hierarchy', 'read');
    this.billing = this.perm.capable('manage_billing', 'read');
    this.licenses = this.perm.capable('manage_licenses', 'read');
    // this.manageTickets = this.perm.capable('manage tickets', 'read');
    // this.manageInventory = this.perm.capable('manage inventory', 'read');
    this.manageImportExport = this.perm.capable('manage_import_export', 'read');
    this.manageShifts = this.perm.capable('manage_shifts', 'read');
    // this.manageGeofence = this.perm.capable('manage geo fence', 'read');
    // this.manageNotification = this.perm.capable('manage notification', 'read');
    // this.drivers = this.perm.capable('drivers', 'read');
    // this.fleetSetup = this.perm.capable('fleet setup', 'read');
    this.module = this.perm.capable('manage_modules', 'read');
    this.workflow = this.perm.capable('manage_workflow', 'read');

    this.calendlyIntegration = this.perm.capable('calendly_integration', 'read');

    this.customerSurveyLink = this.perm.capable('customer_survey_link', 'read');



    this.assets = this.perm.capable('assets', 'read');
    this.jobs = this.perm.capable('job_order', 'read');
    this.tickets = this.perm.capable('tickets', 'read');

    this.packages = this.perm.capable('packages', 'read');

    this.users = this.perm.capable("manage_users", "read");
    this.teams = this.perm.capable('teams', 'read');

    var profileInfo = JSON.parse(this.auth.getProfileInfo());
    this.addonFeature = this.auth.getAddonFeatureLists();
    this.salePer = this.findMenuPermissionsSALES(profileInfo.tenantCategories);
    this.servicePer = this.findMenuPermissionsSERVICE(profileInfo.tenantCategories);
    this.fleetPer = this.findMenuPermissionsFLEET(profileInfo.tenantCategories);

    this.site = this.perm.capable("site", "read");
    this.project = this.perm.capable("project", "read");

    var menuPerm: any = localStorage.getItem('menuPermissions')
    var menuPermissions = JSON.parse(menuPerm);
    this.menuType = sessionStorage.getItem('menuType') ? sessionStorage.getItem('menuType') : menuPermissions.defaultTenantCategory;


  }

// ------------------- Pass menu Items to Setup frame with translation Data
getMenuNodeWithData2(): Observable<any[]> {
  this.initPermission()
  
  this.packageCode = localStorage.getItem('packageCode'); // Get the user's package code
   this.tenantPackages = this.auth.getPackageCodeWithList('INVENTORY');
  if(this.tenantPackages.packageCode == 'Old'){
       this.displayAssets = this.addonFeature.addonINVENTORY == 'INVENTORY' ? true : false
    }else{
      this.displayAssets = true
   }

/////  get tenant packages for project
   this.tenantPackagesProject = this.auth.getPackageCodeWithList('PROJECT');
    if(this.tenantPackagesProject.packageCode == 'Old'){
       this.displayProject = this.addonFeature.addonPROJECT == 'PROJECT' ? false : true
    }else{
      this.displayProject = false
   }
   // get tenant packages for tickets
  var tenantPackagesTickets = this.auth.getPackageCodeWithList('SLA');
    if(tenantPackagesTickets.packageCode == 'Old'){
       this.displayTickets = this.addonFeature.addonSLA == 'SLA' ? true : false
    }else{
      if( this.auth.getAddonPackageListsToHide('SLA') == false ){ // we are hiding asset contract menu from profile if SLA is added in hidden package list
        this.displayTickets = false
      }else{
      this.displayTickets = tenantPackagesTickets.addonPackageList == 'SLA' ? true : false
      }
   }
   // get tenant packages for workflow
   var tenantPackagesWorkflow = this.auth.getPackageCodeWithList('WORKFLOW');
     if(tenantPackagesWorkflow.packageCode == 'Old'){
       this.displayWorkflow = this.addonFeature.addonWORKFLOW == 'WORKFLOW' ? false : true
    }else{
      this.displayWorkflow = false // if the WORKFLOW package is new, hide it
   }

    /***********End Check if the WORKFLOW2 package is old or new ***********/
      var tenantPackagesWORKFLOW2 = this.auth.getPackageCodeWithList("WORKFLOW2");
      if (localStorage.getItem("packageCode") == "Old") {
        this.displayNewWORKFLOW2 = this.addonFeature.addonWORKFLOW2 == "WORKFLOW2" ? false : true;
      } else {
        if (this.auth.getAddonPackageListsToHide("WORKFLOW2")) {
          this.displayNewWORKFLOW2 = tenantPackagesWORKFLOW2.addonPackageList == "WORKFLOW2" || this.addonFeature.addonWORKFLOW2 == "WORKFLOW2"
              ? false : true; // determine the visibility of WORKFLOW2
        } else {
          this.displayNewWORKFLOW2 = true; // if WORKFLOW2 is not hidden, display it
        }
      }

/* Check if the package code is not old and WORKFLOW2 is displayed */
   if(localStorage.getItem("packageCode") != "Old" && this.displayNewWORKFLOW2){
       // Add any specific logic for old package code here if needed
      this.displayWorkflow = false; // if WORKFLOW2 is displayed, ensure WORKFLOW is also displayed             
     
   }
//   console.log(this.displayWorkflow, 'displayNewWORKFLOW2:', this.displayNewWORKFLOW2,"====",this.addonFeature.addonWORKFLOW2);
  //  debugger;


   // get tenant packages for label
    var tenantPackagesLabel = this.auth.getPackageCodeWithList('LABEL');
    if(tenantPackagesLabel.packageCode == 'Old'){
          this.displayLabel = this.addonFeature.addonLABEL == 'LABEL' ? true : false
        }else{
          this.displayLabel = this.auth.getAddonPackageListsToHide('LABEL')
      }
// get tenant packages for PMV
      var tenantPackagesPM = this.auth.getPackageCodeWithList('PM');
        if(tenantPackagesPM.packageCode == 'Old'){
          this.displayPM = this.addonFeature?.addonDYNAMICMAINTENANCE == 'DYNAMIC_MAINTENANCE' ? true : false
        }else{
          this.displayPM = this.auth.getPackageCodeWithList('PM').addonPackageList == 'PM' ? true : false
         }

  /***********Check if the PMV3 package is old or new ***********/
        var tenantPackagesPM3 = this.auth.getPackageCodeWithList('PM3');// Get the tenant's package information
         if (localStorage.getItem("packageCode") == "Old") { // Check if the package is old
          this.displayNewPM3 =this.addonFeature.addonPM3 == "PM3" ? true : false; // Show PMV3 menu if the addon feature is available
        } else {
           if(this.auth.getAddonPackageListsToHide('PM3')){ // we are hiding asset contract menu from profile if PROJECT is added in hidden package list
             this.displayNewPM3 = (tenantPackagesPM3.addonPackageList == 'PM3' || this.addonFeature.addonPM3 == "PM3") ? true : false // Show PMV3 menu if the addon package list includes PMV3
          }else{
            this.displayNewPM3 = false
          }
        }


      // get tenant packages for machine specialist
      var tenantPackagesJOTemp = this.auth.getPackageCodeWithList('JO_TASK_TEMPLATE');
        if(tenantPackagesJOTemp.packageCode == 'Old'){
          this.displayJoTemp = this.addonFeature.addonJOTEMPLATE == 'JO_TEMPLATE' ? true : false
        }else{
          this.displayJoTemp = true
      }


       // get tenant packages for machine specialist
      var tenantPackagesSurvey = this.auth.getPackageCodeWithList('SURVEY');
        if(tenantPackagesSurvey.packageCode == 'Old'){
          this.displaySurvey = this.addonFeature.addonSURVEY == 'SURVEY' ? true : false
        }else{
          this.displaySurvey = true
      }

       if(this.tenantPackages.packageCode == 'Old'){
          this.displayConReq = this.addonFeature.addonCONREQ == 'CON_REQ' ? true : false
        }else{
        this.displayConReq = true
        }

   console.log("Module", this.displayContract,this.packageCode,"Inventory Addon", this.displayAssets);

   var profileInfo = JSON.parse(this.auth.getProfileInfo());
    var profileName = localStorage.getItem('profileName');
      if(this.packageCode == 'Old'){ // If the package code is 'Old', set LicenseBilling to false
            this.LicenseBilling = false
      }else{
         if(profileInfo.billingUser){ // If the profile name is 'Admin' and billingUser is true, set LicenseBilling to true
            this.LicenseBilling = false 
         }else if(profileInfo.billingUser === false){ // If billingUser is false, set LicenseBilling to true
         this.LicenseBilling = true
        }else {
          this.LicenseBilling = true // Set LicenseBilling to false by default
        }

    }

    /** Logic to show/hide new Type menu in setup based on package and hide list : show only when JO2 addOn is there **/
    var tenantPackagesJO2 = this.auth.getPackageCodeWithList('JO2');; // Get the tenant's package information
    if (this.packageCode == "Old") { // Check if the package is old
      //Hide Type menu for old customers with no JO2 addOn. IF Old customers have JO2 addOn, show Type menu
      this.isJOTypeHidden =this.addonFeature.addonJO2 == "JO2" ? false : true;
    } else {
      if(this.auth.getAddonPackageListsToHide('JO2') ){ 
        // Show Type menu if the addon package list includes JO2, OR addon feature includes JO2. Hide otherwise
        this.isJOTypeHidden = (tenantPackagesJO2.addonPackageList == 'JO2' || this.addonFeature.addonJO2 == "JO2") ? false : true
      }else{
        this.isJOTypeHidden = true;
      }
    }

    /**to show/hide mansor iframe as Costing menu for mansor tenant */
    this.isMansorTenant = this.addonFeature.addonMANSOR == "MANSOR" ? true : false;
    console.log(this.isMansorTenant, 'isMansorTenant')

    /************ Hide menu base on package hide list ************/
      this.hideBaseOnPackage.approval = this.auth.getAddonPackageListsToHide('CON_REQ');
      console.log(this.hideBaseOnPackage.approval,"====approval")

      if(this.auth.getAddonPackageListsToHide('DD_CONFIG_ASSET_STATUS') == false && this.auth.getAddonPackageListsToHide('DD_CONFIG_ASSET_TYPE') == false && this.auth.getAddonPackageListsToHide('DD_CONFIG_ASSET_CAT') == false && this.auth.getAddonPackageListsToHide('DD_CONFIG_ASSET_SUB_CAT') == false){ // Hide asset picklist menu if both ASSET_STATUS and ASSET_TYPE  in package list
        this.hideBaseOnPackage.assetPicklist = false
      }
       this.hideBaseOnPackage.assetListView = this.auth.getAddonPackageListsToHide('LISTVIEW_ASSETS')
      
      /////==========================================================================================================================
       this.hideBaseOnPackage.customerListView = this.auth.getAddonPackageListsToHide('LISTVIEW_CUSTOMER')
       this.hideBaseOnPackage.customerPicklist = this.auth.getAddonPackageListsToHide('DD_CONFIG_CUSTOMER')
      /////==========================================================================================================================
       this.hideBaseOnPackage.jobOrderListView = this.auth.getAddonPackageListsToHide('LISTVIEW_JO')
      
       if(this.auth.getAddonPackageListsToHide('DD_CONFIG_JO_STATUS') == false && this.auth.getAddonPackageListsToHide('DD_CONFIG_JO_TYPE') == false && this.auth.getAddonPackageListsToHide('DD_CONFIG_JO_SFR') == false)
        { // Hide job order picklist menu if both JOB_ORDER_STATUS and JOB_ORDER_TYPE  in package list
          this.hideBaseOnPackage.jobOrderPicklist = false
        }
       /////==========================================================================================================================
        this.hideBaseOnPackage.productListView = this.auth.getAddonPackageListsToHide('LISTVIEW_SPARE_PARTS')
      
      /////==========================================================================================================================
      this.hideBaseOnPackage.pmListView = this.auth.getAddonPackageListsToHide('LISTVIEW_PM')
      
      /////==========================================================================================================================
      if(this.auth.getAddonPackageListsToHide('LISTVIEW_SALES_ORDERS') == false ){ // Hide asset picklist menu if  LISTVIEW_SALES_ORDERS  in package list
        this.hideBaseOnPackage.salesOrderListView = false
      }
       this.hideBaseOnPackage.salesOrderPicklist = this.auth.getAddonPackageListsToHide('DD_CONFIG_SALES_ORDER')
      /////===========================================PROJECT===============================================================================
       this.hideBaseOnPackage.projectListView = this.auth.getAddonPackageListsToHide('LISTVIEW_PROJECTS')
      
      if(this.auth.getAddonPackageListsToHide('PROJECT') == false ){ // Hide Project menu if  PROJECT  in package list
        this.displayProject = true
      }
      this.hideBaseOnPackage.projectPicklist = this.auth.getAddonPackageListsToHide('DD_CONFIG_PROJECTS')
      /////=============================================SITE =============================================================================
      this.hideBaseOnPackage.projectListView = this.auth.getAddonPackageListsToHide('LISTVIEW_SITES')
      
      this.hideBaseOnPackage.site = this.auth.getAddonPackageListsToHide('SITE')
      this.hideBaseOnPackage.sitePicklist = this.auth.getAddonPackageListsToHide('DD_CONFIG_SITES')
      /////===================================TASK=======================================================================================
       this.hideBaseOnPackage.taskListView = this.auth.getAddonPackageListsToHide('LISTVIEW_TASKS')
       /// get survey menu hide/show from Hide package list
        if(this.auth.getAddonPackageListsToHide('JO_TASK_TEMPLATE') == false ){ // Hide Survey menu if  SURVEY  in package list
          this.displayJoTemp = false // we are hiding survey menu from profile but showing survey button in JO view page if survey is added in package list
        }
      /////=======================================TICKET===================================================================================
        this.hideBaseOnPackage.ticketListView = this.auth.getAddonPackageListsToHide('LISTVIEW_TICKETS')
      
        this.hideBaseOnPackage.ticketPicklist = this.auth.getAddonPackageListsToHide('DD_CONFIG_TICKETS')
      /////==========================================================================================================================
    //  get tenant packages for contract
      this.tenantPackagesContract = this.auth.getPackageCodeWithList('CONTRACT');

        if(this.tenantPackagesContract.packageCode == 'Old'){
            this.displayContract =  true
          }else{
            if( this.auth.getAddonPackageListsToHide('CONTRACT') ){ // we are hiding asset contract menu from profile if CONTRACT is added in hidden package list
            this.hideBaseOnPackage.contracts = this.tenantPackagesContract.addonPackageList == 'CONTRACT' ? true : false
            }else{
              this.displayContract = false
            }
        }
      this.hideBaseOnPackage.contractListView = this.auth.getAddonPackageListsToHide('LISTVIEW_CONTRACT')
      /////==========================================================================================================================
      this.hideBaseOnPackage.inventory = this.auth.getAddonPackageListsToHide('INVENTORY') // we are hiding asset contract menu from profile if CONTRACT is added in hidden package list

      /////==========================================================================================================================
      this.hideBaseOnPackage.hierarchy = this.auth.getAddonPackageListsToHide('HIERARCHY') // we are hiding asset contract menu from profile if CONTRACT is added in hidden package list
       /////==========================================================================================================================
      this.hideBaseOnPackage.skill = this.auth.getAddonPackageListsToHide('SKILLS') // we are hiding asset contract menu from profile if CONTRACT is added in hidden package list
      /////==========================================================================================================================
      if(this.auth.getAddonPackageListsToHide('SURVEY') == false ){ // Hide Survey menu if  SURVEY  in package list
        this.displaySurvey = false
      }
      
      /////==========================================================================================================================
     // general service zone menu hide/show
      this.hideBaseOnPackage.general = this.auth.getAddonPackageListsToHide('DD_CONFIG_SERVICE_ZONE')
    //customer portal config menu show/hide 
    var tenantPackageCustomerPortal = this.auth.getPackageCodeWithList("CUSTOMER_PORTAL"); 
    if (localStorage.getItem("packageCode") == "Old") {
      // Check if the package is old
      this.displayCustomerPortal =
        this.addonFeature.addonCustomerPortal == "CUSTOMER_PORTAL" ? true : false;
    } else {
      if (this.auth.getAddonPackageListsToHide("CUSTOMER_PORTAL")) {
        this.displayCustomerPortal =
          tenantPackageCustomerPortal.addonPackageList == "CUSTOMER_PORTAL" ||
          this.addonFeature.addonCustomerPortal == "CUSTOMER_PORTAL" ? true: false; 
      } else {
        this.displayCustomerPortal = false;
      }
    }

    var tenantPackagesSETUP2 = this.auth.getPackageCodeWithList("SETUP2"); 
    if (localStorage.getItem("packageCode") == "Old") {
      this.displayNewAsset = this.addonFeature.addonSETUP2 == "SETUP2" ? true : false;
    }
    else{
      if (this.auth.getAddonPackageListsToHide("SETUP2")) {
        this.displayNewAsset = tenantPackagesSETUP2.addonPackageList == "SETUP2" || this.addonFeature.addonSETUP2 == "SETUP2" ? true : false;
      } else {
        this.displayNewAsset = false;
      }
    }

    console.log(this.hideBaseOnPackage,"====assetPicklist",this.hideBaseOnPackage.hierarchy)
      
   return this.languageTranslateService.wordSrc$.pipe(
    map(data => {
      if (Object.keys(data).length === 0) {
        return []; // Return an empty array if no data is available
      }
      const translate = data;
      const rootLevelNodes = [
        {
          name: translate?.general.label.singular, value: "general", hide: !this.company, data: [
            { name: translate?.setup.general.organizationDetails.label.singular, value: "organisationInformation", routerLink: "generalSettings" },
            // { name: "Default Formats", value: "defaultFormats", routerLink: "defaultFormats" },
            { name: translate?.setup.general.licenseBilling.label.singular, value: "LicenseBilling", routerLink: "licenseBilling",hide:this.LicenseBilling },
            { name: translate?.setup.general.workingHours.label.singular, value: "orgWideWorkingHours", routerLink: "orgWorkingHours" },
          ]
        },
        {
          name: translate.setup.configuration.label.plural, value: "systemConfiguration", data: [
            { name: translate?.setup.configuration.systemLabel.label.plural, value: "labels", routerLink: "system/labels" ,hide: this.module && this.displayLabel ? false : true},
            {
              name: translate?.setup.notifications.label.plural, value: "notificationsSettings", data: [], routerLink: "notifications/settings"
            },
            {
              name: "AI", value: "ai", data: [
                {name: translate.setup.configuration.artificialIntelligence.sections.sec0.singular, value: "aiSuggestions", routerLink: "ai/suggestions"},
                {name: translate.setup.configuration.artificialIntelligence.sections.sec6.singular, value: "aiTraining", routerLink: "ai/training"},
              ], hide: this.module && this.addonFeature.addonAI == 'AI' ? false : true
            },
          ]
        },
        {
              name: translate.setup.users.users.label.plural, value: "users", hide: !(this.users || this.manageShifts), data: [
            { name: translate.setup.users.access.label.plural, value: "access", hide: !this.users, routerLink: "profiles" },
            { name: translate.setup.users.approval.label.plural, value: "approval", hide: this.displayConReq && this.hideBaseOnPackage.approval ? false : true, routerLink: "approval" },
            { name: "Drivers", value: "driver", hide: this.users && this.menuType == 'fleet' ? false : true, routerLink: "drivers" },
            { name: translate.setup.users.hierarchy.label.singular,  value: "Hierarchy", hide:!this.hideBaseOnPackage.hierarchy, routerLink: "hierarchy" },
            // { name: translate.setup.users.skills.label.plural, value: "skills", hide: !this.hideBaseOnPackage.skill, routerLink: "skills" },
            { name: translate.setup.users.teams.label.plural, value: "teams", hide: !this.users, routerLink: "teams" },
            { name: translate.setup.users.users.label.plural, value: "user", hide: !this.users, routerLink: "allUser" },
            { name: translate.setup.users.groups.label.plural, value: "userGroups", hide: !this.users || !(this.menuType == 'sales' || this.menuType == 'service'), routerLink: "groups" },
            { name: translate.setup.users.shifts.label.plural, value: "shifts", hide: !this.manageShifts, routerLink: "shifts" },
          ]
        },
        {
          name: translate.setup.modules.label.plural, value: "module", hide: !this.module, data: [
            // { name: "Accessories", value: "accessories", hide: !this.profiles, routerLink: "dashboard/setup/profiles" },
            {
              name: translate.asset.label.plural, value: "assets", hide: this.module && this.displayAssets ? false : true, data: [
                { name: translate.setup.modules.configuration.label.singular, value: "assetDetails", routerLink: "asset/details" },
                { name: translate.setup.modules.types.label.plural, value: "assetTypes", routerLink: "asset/type-standalone", hide: !this.displayNewAsset},
                { name: translate.setup.modules.picklist.label.plural, value: "assetFields", routerLink: "asset/picklist", hide: !this.hideBaseOnPackage.assetPicklist },
                { name: translate.setup.modules.listView.label.plural, value: "assetListView", routerLink: "asset/listView", hide: !this.hideBaseOnPackage.assetListView },
              ]
            },
            { name: translate.contracts.label.plural, value: "contracts", data: [
                { name: translate.setup.modules.listView.label.plural, value: "contractsListView", routerLink: "contracts/listView" },
              ], hide: this.module && this.displayAssets  && (!this.hideBaseOnPackage.contractListView && !this.hideBaseOnPackage.contracts)? false : true
            },
            {
              name: translate.customer.label.plural, value: "customer", data: [
                { name: translate.setup.modules.configuration.label.singular, value: "customerConfiguration", routerLink: "customer/config" },
                { name: translate.setup.modules.picklist.label.plural, value: "customerPicklist", routerLink: "customer/picklist", hide: !this.hideBaseOnPackage.customerPicklist },
                // { name: "Sector Mapping", value: "customerSectMap", routerLink: "customer/mapping" },
                { name: translate.setup.modules.listView.label.plural, value: "customerListView", routerLink: "customer/listView", hide: !this.hideBaseOnPackage.customerListView},
              ]
            },
           {
              name: translate?.general.label.singular, value: "generalServiceZone", hide: !this.hideBaseOnPackage.general,data: [
                { name: translate.setup.modules.picklist.label.plural, value: "picklist", routerLink: "general/picklist" },
              ]
            },
            { name: translate.setup.geofence.label.plural, value: "geofencing", data: [], hide: !this.module, routerLink: "geofencing" },
            {
              name: translate.inventory.label.plural, value: "inventory", data: [
                { name: translate.setup.modules.inventory.bins.label.plural +' '+ translate.setup.label.singular, value: "inventorySetup", routerLink: "inventory/binsSetup" },
              
                // { name: translate.setup.modules.inventory.zones.label.plural, value: "inventoryZone", routerLink: "inventory/zone" },
                // { name: translate.setup.modules.inventory.bins.label.plural, value: "inventoryBin", routerLink: "inventory/bin" }
              ], hide: this.displayAssets && this.module && this.hideBaseOnPackage.inventory ? false : true
            },
        
            {
              name: translate.jobOrder.label.plural, value: "jobOrder", hide: (this.menuType === 'service' && this.servicePer) || (this.menuType === 'sales' && this.servicePer) ? false : true, data: [
                { name: translate.setup.modules.configuration.label.singular, value: "jobOrderDetails", routerLink: "jobOrder/details" },
               
                { name: translate.setup.modules.picklist.type.label.plural, value: "jobOrderType", routerLink: "jobOrder/type-standalone", hide: this.isJOTypeHidden },

                { name: translate.setup.modules.picklist.label.plural, value: "jobOrderPicklist", routerLink: "jobOrder/picklist" },
                { name: translate.setup.modules.templates.label.plural, value: "jobOrderTemplates", routerLink: "jobOrder/templates", hide:this.workflow && (this.addonFeature.addonMS == 'MACHINE_SPECIALIST' || this.displayJoTemp) ? false : true},
                { name: translate.setup.modules.faultResolution.label.singular, value: "jobOrderFaultsResolution", routerLink: "jobOrder/faultresolution" },
                { name: translate.setup.modules.listView.label.plural, value: "jobOrderListView", routerLink: "jobOrder/listView", hide: !this.hideBaseOnPackage.jobOrderListView },
                { name: translate.setup.modules.assignmentRule.label.plural, value: "jobOrderAssignmentRule", routerLink: "jobOrder/assignment-rule",hide:this.displayNewWORKFLOW2 },
                { name: translate.setup.workflows.label.plural, value:"jobOrder/workflows-standalone", data: [], routerLink: "workflows-standalone/all-jobOrder",hide:this.displayNewWORKFLOW2 },
                // { name: 'PDFs', value: "pdf", routerLink: "jobOrder/pdf" },
              ]
            },
            
            { name: translate.preventiveMaintenance.label.plural, value: "preventiveMaintenance", data: [
              { name: translate.setup.modules.configuration.label.singular, value: "preventiveMaintenanceDetails", routerLink: "preventiveMaintenance/configuration" },
              { name: translate.setup.modules.listView.label.plural, value: "preventiveMaintenanceListView", routerLink: "preventiveMaintenance/listView",hide: !this.hideBaseOnPackage.pmListView },
            ], hide: this.displayPM && !this.displayNewPM3 ? false : true ,
           },
            {
              name: translate.product.label.plural, value: "products",hide:!this.hideBaseOnPackage.productListView, data: [
                { name: translate.setup.modules.picklist.label.plural, value: "productsPicklist", routerLink: "products/picklist" },
                { name: translate.setup.modules.listView.label.plural, value: "productsListView", routerLink: "products/listView" },
              ]
            },
            /*{
              name: translate.product.label.plural, value: "iframe", hide:!this.isMansorTenant, data: []
            },*/
            {
              name: translate.project.label.plural, value: "projects", hide: this.displayProject, data: [
                { name: translate.setup.modules.configuration.label.singular, value: "projectDetails", routerLink: "projects/details",hide: this.tenantPackagesProject.addonPackageList == 'PROJECT' ? false : true },
                { name: translate.setup.modules.picklist.label.plural, value: "projectsPicklist", routerLink: "projects/picklist" , hide: !this.hideBaseOnPackage.projectPicklist},
                { name: translate.setup.modules.listView.label.plural, value: "assetListView", routerLink: "projects/listView", hide: !this.hideBaseOnPackage.projectListView},
              ]
            },
            {
              name: translate.salesOrder.label.plural, value: "salesOrder", hide: !this.hideBaseOnPackage.salesOrderPicklist && !this.hideBaseOnPackage.salesOrderListView, data: [
                { name: translate.setup.modules.configuration.label.singular, value: "salesOrderDetails", routerLink: "salesOrder/details",hide: !this.hideBaseOnPackage.salesOrderPicklist },
                { name: translate.setup.modules.picklist.label.plural, value: "salesOrderPicklist", routerLink: "salesOrder/fields",hide: !this.hideBaseOnPackage.salesOrderPicklist },
                { name: translate.setup.modules.listView.label.plural, value: "salesListView", routerLink: "salesOrder/listView",hide: !this.hideBaseOnPackage.salesOrderListView },
              ]
            },
            {
              name: translate.site.label.plural, value: "sites", hide: !this.hideBaseOnPackage.site, data: [
                { name: translate.setup.modules.configuration.label.singular, value: "siteDetails", routerLink: "sites/details",hide:this.auth.getPackageCodeWithList('SITE').addonPackageList == 'SITE' ? false : true },
                { name: translate.setup.modules.picklist.label.plural, value: "sitesPicklist", routerLink: "sites/picklist",hide: !this.hideBaseOnPackage.sitePicklist },
                { name: translate.setup.modules.listView.label.plural, value: "assetListView", routerLink: "sites/listView", hide: !this.hideBaseOnPackage.siteListView },
              ]
            },
            { name: "Subcontractor", value: "subContractor", data: [], routerLink: "fleetSetup/subContractors", hide: this.module && this.menuType == 'fleet' ? false : true },
            {
              name:translate.task.label.plural, value: "task", hide:!this.displayJoTemp && !this.hideBaseOnPackage.taskListView ? true : false, data: [
                // { name: translate.setup.modules.configuration.label.singular, value: "taskConfiguration", routerLink: "tasks/config" }, // CS-6290
                // { name: translate.setup.modules.picklist.label.plural, value: "taskPicklist", routerLink: "" },
                { name: translate.setup.modules.templates.label.plural, value: "taskTemplates", routerLink: "tasks/templates",hide:this.addonFeature.addonMS == 'MACHINE_SPECIALIST' || this.displayJoTemp ? false : true,},
                { name: translate.setup.modules.listView.label.plural, value: "assetListView", routerLink: "tasks/listView", hide: !this.hideBaseOnPackage.taskListView },
                { name: translate.setup.modules.procedure.label.plural, value: "taskProcedure", routerLink: "tasks/procedure", hide: this.isJOTypeHidden},
              ]
            },
            {
              name: translate.ticket.label.plural, value: "ticket", hide:  this.displayTickets ? false : true, data: [
                { name: translate.setup.modules.configuration.label.singular, value: "ticketDetails", routerLink: "ticket/details",hide:this.auth.getPackageCodeWithList('TICKETS').addonPackageList == 'TICKETS' ? false : true },
                { name: translate.setup.modules.picklist.label.plural, value: "ticketFields", routerLink: "ticket/fields",hide: !this.hideBaseOnPackage.ticketPicklist },
                { name: translate.setup.modules.listView.label.plural, value: "ticketListView", routerLink: "ticket/listView", hide: !this.hideBaseOnPackage.ticketListView },
              ]
            },
              
          ]
        },
       
        {
          name: translate.setup.workflows.label.plural, value: "workflow", hide: this.workflow && this.menuType !== 'fleet' ? false : true, data: [
         // name: "Workflows", value: "workflows",  data: [
            // {
            //   name: "Checklist", value: "checklist", data: [
            //     { name: "Task List", value: "taskList", routerLink: "checklist/taskList" },
            //     { name: "Equipment", value: "equipment", routerLink: "checklist/equipment" },
            //     { name: "Maintenance Tasks", value: "maintenanceTasks", routerLink: "checklist/maintenance" },
            //     { name: "Departments", value: "departments", routerLink: "checklist/departments" },
               
            //   ], hide: this.addonFeature.addonTTL == 'TTL_QC' && this.menuType != 'fleet' ? false : true
            // },
            {
              name: translate.setup.checklist.label.plural, value: "checklists", data: [], hide:this.workflow && this.menuType != 'fleet' && (this.addonFeature.addonMS == 'MACHINE_SPECIALIST' || this.displayAssets) ? false : true,routerLink: "checklist"
            },
            { name: translate.setup.devices.label.plural, value: "devices", data: [], hide: this.addonFeature.addonCHUBB == 'CHUBB' ? false : true, routerLink: "chubb/devices" },
            // { name: "Notifications", value: "notification", data: [], hide: this.addonFeature.addonMAGNUM == 'MAGNUM' && this.manageNotification ? false : true, routerLink: "dashboard/setup/notifications" },
            { name: translate.setup.workflows.label.plural, value: "workflows", data: [], routerLink: "workflows",hide:!this.displayWorkflow && this.displayNewWORKFLOW2 ? false : true },
            { name: translate.setup.workflows.label.plural, value: "workflows-standalone", data: [], routerLink: "workflows-standalone",hide:this.displayNewWORKFLOW2 },
            { name: translate?.setup.notifications.label.plural, value: "notifications", data: [], routerLink: "action/notifications",hide:(!this.displayWorkflow || !this.displayNewWORKFLOW2) && this.auth.getAddonPackageListsToHide('NOTIFICATION_CUSTOM') ? false : true },
            {
              name: translate.setup.sla.label.plural, value: "sla", data: [
                { name: translate.setup.sla.packages.label.plural, value: "inventoryLocation", routerLink: "sla/package" },
                { name: translate.setup.sla.steps.label.plural, value: "inventoryLocation", routerLink: "sla/step" },
                { name: translate.setup.sla.businessHours.label.singular, value: "inventoryLocation", routerLink: "sla/businessHours" },

              ], hide: this.displayTickets && this.module ? false : true
            }
          ]
        },
        { name: translate.setup.templates.label.plural, value: "templates", data: [
            { name: translate.setup.templates.email.label.plural, value: "emailTemplates", routerLink: "templates/email" },
          ], hide:(!this.displayWorkflow || !this.displayNewWORKFLOW2)&& this.auth.getAddonPackageListsToHide('NOTIFICATION_CUSTOM') ? false : true
        },
        { name: translate.setup.importExport.label.singular, value: "import", data: [], hide: !this.manageImportExport, routerLink: "dashboard/setup/import" },
        {name:  translate.setup.integrations.label.plural, value: "integrations",
          data: [
            // Existing Integration/Configuration
            { name: translate.setup.modules.configuration.label.singular, value: "integrationConfig", routerLink: "integration/config",hide: this.calendlyIntegration ? false : true },
            // New Integration Connector v2
           // { name: 'App', value: "appConnector", routerLink: "appConnector" },
            { name: translate?.setup.integrations.oauth.label.singular, value: "oauth", routerLink: "oauth" },
          ],
        },
        { name:  translate.setup.customerSurvey.label.singular, value: "survey", data: [], routerLink: "dashboard/setup/survey",hide: (this.customerSurveyLink && this.displaySurvey ? false : true), },
        { name: 'Customer Portal Configuration', value: "portal-configuration", data: [], routerLink:"dashboard/setup/portal-configuration", hide: !this.displayCustomerPortal}, //hide when displayCustomerPortal is false
      ];

      return rootLevelNodes;
    })
  );
}


// getMenuTaskWithData(): Observable<any[]> {
//   //this.initPermission()
//   return this.languageTranslateService.wordSrc$.pipe(
//     map(data => {
//       if (Object.keys(data).length === 0) {
//         return []; // Return an empty array if no data is available
//       }
//       const translate = data;
//       const rootLevelNodes = [
//         { name: "Queue (10)", value: "queue", data: [], routerLink: "dashboard/setup/fleetSetup/fleetConfig" },
  
//         {
//           name: "My Task", value: "general", data: [
//             { name: "All Task (14)", value: "organisationInformation", routerLink: "generalSettings" },
//             { name: "Today (5)", value: "defaultFormats", routerLink: "defaultFormats" },
//             { name: "Upcoming (3)", value: "LicenseBilling", routerLink: "licenseBilling" },
//             { name: "Completed (11)", value: "orgWideWorkingHours", routerLink: "orgWorkingHours" },
//           ]
//         },
//         {
//           name: "Staf Task", value: "users", data: [
//             { name: "All Task (14)", value: "organisationInformation", routerLink: "generalSettings" },
//             { name: "Today (5)", value: "defaultFormats", routerLink: "defaultFormats" },
//             { name: "Upcoming (3)", value: "LicenseBilling", routerLink: "licenseBilling" },
//             { name: "Completed (11)", value: "orgWideWorkingHours", routerLink: "orgWorkingHours" },
//           ]
//         },
  
//         {
//           name: "Team Task", value: "sla", data: [
//             { name: "All Task (14)", value: "organisationInformation", routerLink: "generalSettings" },
//             { name: "Today (5)", value: "defaultFormats", routerLink: "defaultFormats" },
//             { name: "Upcoming (3)", value: "LicenseBilling", routerLink: "licenseBilling" },
//             { name: "Completed (11)", value: "orgWideWorkingHours", routerLink: "orgWorkingHours" },
//           ]
//         }
//       ]

//       return rootLevelNodes;
//     })
//   );
// }


  

  getMenuTask() {
    this.rootLevelNodes = [
      { name: "Queue (10)", value: "queue", data: [], routerLink: "dashboard/setup/fleetSetup/fleetConfig" },

      {
        name: "My Task", value: "general", data: [
          { name: "All Task (14)", value: "organisationInformation", routerLink: "generalSettings" },
          { name: "Today (5)", value: "defaultFormats", routerLink: "defaultFormats" },
          { name: "Upcoming (3)", value: "LicenseBilling", routerLink: "licenseBilling" },
          { name: "Completed (11)", value: "orgWideWorkingHours", routerLink: "orgWorkingHours" },
        ]
      },
      {
        name: "Staf Task", value: "users", data: [
          { name: "All Task (14)", value: "organisationInformation", routerLink: "generalSettings" },
          { name: "Today (5)", value: "defaultFormats", routerLink: "defaultFormats" },
          { name: "Upcoming (3)", value: "LicenseBilling", routerLink: "licenseBilling" },
          { name: "Completed (11)", value: "orgWideWorkingHours", routerLink: "orgWorkingHours" },
        ]
      },

      {
        name: "Team Task", value: "sla", data: [
          { name: "All Task (14)", value: "organisationInformation", routerLink: "generalSettings" },
          { name: "Today (5)", value: "defaultFormats", routerLink: "defaultFormats" },
          { name: "Upcoming (3)", value: "LicenseBilling", routerLink: "licenseBilling" },
          { name: "Completed (11)", value: "orgWideWorkingHours", routerLink: "orgWorkingHours" },
        ]
      }
    ]
    return this.rootLevelNodes
  }


  /************************************* Main Menu Permission Variable Diaply **********************/
  findMenuPermissionsSALES(tenantCategories: any) {
    var saleIndex = tenantCategories.indexOf("SALES");
    if (saleIndex != -1) {
      return true;
    } else {
      return false
    }

  }
  findMenuPermissionsSERVICE(tenantCategories: any) {

    var serviceIndex = tenantCategories.indexOf("SERVICE");
    if (serviceIndex != -1) {
      return true;
    } else {
      return false
    }

  }
  findMenuPermissionsFLEET(tenantCategories: any) {

    var fleetIndex = tenantCategories.indexOf("FLEET");
    if (fleetIndex != -1) {
      return true;
    } else {
      return false
    }
  }
}
